import { lazy } from 'react';
import {
    CATALOGUE_AUTH,
    READ_PERMISSION,
    CREATE_PERMISSION,
    UPDATE_PERMISSION,
} from 'src/constants/permissions';
import { PermissionsGuard } from 'src/routing/components';

export const Routes = [
    {
        exact: true,
        guard: PermissionsGuard,
        roles: {
            permission: CATALOGUE_AUTH,
            crud: CREATE_PERMISSION,
        },
        path: '/create/catalogue',
        component: lazy(
            () => import('src/views/catalogue/CatalogueCreateView')
        ),
    },
    {
        exact: true,
        guard: PermissionsGuard,
        roles: {
            permission: CATALOGUE_AUTH,
            crud: READ_PERMISSION,
        },
        path: '/management/catalogue/:id',
        component: lazy(
            () => import('src/views/catalogue/CatalogueDetailsView')
        ),
    },
    {
        exact: true,
        guard: PermissionsGuard,
        roles: {
            permission: CATALOGUE_AUTH,
            crud: UPDATE_PERMISSION,
        },
        path: '/management/catalogue/:id/edit',
        component: lazy(() => import('src/views/catalogue/CatalogueEditView')),
    },
    {
        exact: true,
        guard: PermissionsGuard,
        roles: {
            permission: CATALOGUE_AUTH,
            crud: READ_PERMISSION,
        },
        path: '/management/catalogue',
        component: lazy(() => import('src/views/catalogue/CatalogueListView')),
    },
];
